import type { Referral } from '../referrals/referral'
import type { TaggedPersonDto } from '../tags/tagged-person.dto'

export class Person {
    personId: string
    name: string
    phone: string
    image?: string
    email?: string
    born?: Date
    createdAt?: Date
    date?: Date
    donotPhone?: boolean
    donotEmail?: boolean
    donotWA?: boolean
    donotSms?: boolean
    donotLogin?: boolean
    address?: string
    district?: string
    CEP?: string
    number?: string
    complement?: string
    city?: string
    state?: string
    referralId?: string
    referral?: Referral
    document?: string
    RG?: string
    comments?: string
    businessName?: string
    businessId?: string
    searchItemId?: string
    status?: number
    gender?: 'male' | 'female' | 'other' | ''
    tag: TaggedPersonDto[]
    requestedAt?: Date
    country?: string
    passport?: string
}
